module.exports = __webpack_public_path__ + "static/media/bells.92a451c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/bells.mp3
// module id = 9nKn
// module chunks = 74